<template>
    <div class="page-container">
        <div class="container-filter">
            <el-form ref="filterRef" :model="params" inline>
                <div>
                    <el-form-item prop="name" label="批次名称：">
                        <el-input v-model="params.name" placeholder="请输入批次名称" clearable />
                    </el-form-item>
                    <el-form-item prop="status" label="状态：">
						<el-select v-model="params.status" placeholder="请选择状态" clearable>
							<el-option
								v-for="item in statusOptions"
								:key="item.id"
								:label="item.label"
								:value="item.id"
							/>
						</el-select>
                    </el-form-item>
                </div>
                <div>
                    <el-button @click="resetFilter">重置</el-button>
                    <el-button type="primary" @click="getTableData()" :loading="loading">查询</el-button>
                </div>
            </el-form>
        </div>
        <div class="container-table">
            <div class="table-header">
                <div>数据列表</div>
                <div>
                    <el-button type="primary" @click="add" v-if="mypowerlimits.pcgl_tj">新增</el-button>
                    <el-button type="primary" @click="exportRecord">导出</el-button>
                </div>
            </div>
            <el-table :border="true" :data="table.data" v-loading="loading" >
                <el-table-column prop="" label="序号" fixed="left">
                    <template #default="{ $index }">
                        <span>{{ $index + 1 }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="ID" fixed="left" />
                <el-table-column prop="name" label="批次名称" min-width="180" >
                    <template #default="{ row }">
                        <span v-if="mypowerlimits.pcktj && row.status != 3 && row.status != -2" class="skip" @click="goUrl('/batchpayment', { id: row.id, name: row.name })">{{ row.name }}</span>
                        <span v-else>{{ row.name }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="price" label="结算单价（元）" min-width="180" >
					<template #default="{ row }">
                        <span>{{ formatPrice(row.price) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="num" label="总数量"/>
                <el-table-column prop="total" label="总价款（元）" min-width="120" >
					<template #default="{ row }">
                        <span>{{ formatPrice(row.total) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="advance" label="预付款（元）"  min-width="120">
					<template #default="{ row }">
                        <span>{{ formatPrice(row.advance) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="residue" label="余款（元）" min-width="120" >
					<template #default="{ row }">
                        <span>{{ formatPrice(row.residue) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="状态" >
					<template #default="{ row }">
                        <span :style="{ color: statusColor[String(row.status)] }">{{ findLabel(statusOptions, row.status) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="checktime" label="验收时间"  width="120">
					<template #default="{ row }">
                        <span>{{ row.checktime ? $utils.formatDate(row.checktime).split(' ')[0] : '' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="repay_first_day" label="还款首日"  width="120">
					<template #default="{ row }">
                        <span>{{ row.repay_first_day ? $utils.formatDate(row.repay_first_day).split(' ')[0] : '' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="repay_status" label="还款状态" >
					<template #default="{ row }">
                        <el-switch v-if="row.status == 1 || row.status == 2 || row.status == 3" v-model="row.repay_status" :active-value="1"  :inactive-value="-1" @click="recordStatus(row, mypowerlimits.pcgl_hkkg)" :disabled="!mypowerlimits.pcgl_hkkg"/>
                        <span v-else>{{ row.repay_status == 1 ? '开启' : '关闭' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="adminid_name" label="操作人" min-width="120" />
                <el-table-column prop="addtime" label="操作时间"  width="180">
                    <template #default="{ row }">
                        <span>{{ row.addtime ? $utils.formatDate(row.addtime) : '' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="210" fixed="right">
                    <template #default="{ row }">
						<el-button type="primary" size="small" @click="handleEdit(row)" v-if="mypowerlimits.pcgl_bj && row.status == 3">编辑</el-button>
						<el-button type="warning" size="small" @click="goUrl('/batchmanagechack', { id: row.id })" v-if="mypowerlimits.pcgl_ys && row.status == 3">验收</el-button>
						<el-button type="primary" size="small" @click="goUrl('/batchmanagechack', { id: row.id, copy: true })" v-if="mypowerlimits.pcgl_ys && (row.status == 4 || row.status == -1)">复制</el-button>
						<el-button type="primary" size="small" @click="goUrl('/batchmanageinfo', { id: row.id })" v-if="mypowerlimits.pcgl_xq && (row.status == -1 || row.status == 1 || row.status == 2 || row.status == 4)">详情</el-button>
                        <el-button type="danger" size="small" @click="handleStop(row)" v-if="mypowerlimits.pcgl_zz && (row.status == 1 || row.status == 2)">终止</el-button>
                        <el-button type="danger" size="small" @click="handleDelete(row)" v-if="mypowerlimits.pcgl_sc && (row.status == 3 || row.status == 4 || row.status == -1)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="tabler-pagination">
                <el-pagination
                    @size-change="getTableData()"
                    @current-change="getTableData"
                    :current-page="params.page"
                    :page-sizes="[20, 50, 100, 1000]"
                    v-model:page-size="params.page_size"
                    :total="table.total"
                    layout="total, sizes, prev, pager, next, jumper"
                />
            </div>
        </div>
		<FormDialog :data="formData" @success="successEvent" />
    </div>
</template>

<script setup>
import { ref, reactive } from 'vue'
import { ElMessageBox, ElNotification, ElMessage } from 'element-plus'
import http from '@/assets/js/http'
import router from '@/router'
import FormDialog from './formDialog'
import dict from '../../../js/dict'

// 获取权限
const mypowerlimits = reactive(JSON.parse(localStorage.getItem('powerlimits')))

const formData = reactive({})

const statusOptions = reactive([ {id: '', label: '全部'} ,...dict.batchStatusOptions ])

const statusColor = reactive({
    '-2': '#FF0000',
    '-1': '#FF00FF',
    '1': '#008000',
    '2': '#333333',
    '3': '#FFA500',
    '4': '#FF4500',
})

// 过滤
const filterRef = ref()
const params = reactive({
	name: '',
	status: '',
    page: 1,
    page_size: 20
})

// 表格
const loading = ref(false)
const table = reactive({
    data: [],
    columns: [],
    total: 0
})

const getTableData = async (page = 1) => {
    params.page = page
    loading.value = true
    try {
        const res = await http.get('RiskControlAdvance/riskList', { params })
		Object.assign(table, res)
    } catch (e) {
        console.log(e)
    }
    loading.value = false
}

const formatPrice = (data) => {
	return data ? ((+data) / 100).toFixed(3) : data 
}

const findLabel = (list, data) => {
	return list.find((item) => item.id === data)?.label
}

// 操作
// 重置查询条件
const resetFilter = () => {
    filterRef.value?.resetFields()
    getTableData()
}

const goUrl = (path, query) => {
	router.push({path, query})
}

const add = ()=> {
	formData.value = { data: {}, api: 'RiskControlAdvance/create', }
}

const handleEdit = (row)=> {
    formData.value = { data: row, api: 'RiskControlAdvance/update', }
}

// 修改状态
const recordStatus = async (row, authority)=> {
    if (!authority) return
    try {
        await http.post('RiskControlAdvance/riskEditInfo', { id: row.id, repay_status: row.repay_status }, { sMsg: true });
    } catch (e) {
        row.repay_status = row.repay_status === 1 ? -1 : 1;
    }
}


// 终止
const handleStop = async (row) => {
	const { name, id } = row
    await ElMessageBox.confirm(`是否终止${name}？`, '提示', { type: 'warning', confirmButtonText: '确定', cancelButtonText: '取消' })
    await http.post('RiskControlAdvance/stop', { id })
    ElNotification.success({ title: '提示', type: 'success', message: '操作成功' })
    getTableData()
}

// 删除
const handleDelete = async (row) => {
	const { name, id } = row
    await ElMessageBox.confirm(`是否删除${name}？`, '提示', { type: 'warning', confirmButtonText: '确定', cancelButtonText: '取消' })
    await http.post('RiskControlAdvance/delete', { id })
    ElNotification.success({ title: '提示', type: 'success', message: '操作成功' })
    getTableData()
}

// 导出
const exportRecord = async () => {
    await http.get('RiskControlAdvance/riskList', { params: { ...params, export: 1 }, sMsg: true })
}

const successEvent = () => {
    getTableData()
}

getTableData()
</script>

<style lang="scss" scoped>
.page-container {
    background-color: #e9eef3;
    .container-filter {
        padding: 12px 24px;
        background-color: #fff;
        .el-form {
            display: flex;
            justify-content: space-between;
        }
        .el-form-item {
            margin-right: 20px;
            margin-bottom: 0px;
        }
    }

    .container-table {
        margin-top: 4px;
        padding: 24px;
        background-color: #fff;
        .table-header {
            display: flex;
            justify-content: space-between;
            margin-bottom: 12px;
        }

        .skip {
            cursor: pointer;
            color: var(--el-color-primary);
        }
        .tabler-pagination {
            display: flex;
            justify-content: space-between;
            margin-top: 12px;
        }
    }
}

.container-drawer {
    .filter-tree {
        margin-top: 24px;
    }
    .drawer-footer {
        margin-top: 24px;
        display: flex;
        justify-content: flex-end;
    }
}
</style>
